import { apiCall } from 'app/dealer/actions';
import { getPostBodyFromFilters } from 'app/dealer/utils';

import * as ActionTypes from './constants';
import {
  DEALER_LISTING_PAUSED_STATE,
  DEALER_LISTING_PUBLISHED_STATE,
  DEALER_PAGINATION_SIZE,
} from './config';

export const getDealerListings = () => {
  return (dispatch, getState) => {
    const { listingsFilters } = getState();
    const size = DEALER_PAGINATION_SIZE;
    const url = '/dealer-portal/listings';
    const postBodyFromFilters = getPostBodyFromFilters(listingsFilters);
    const {
      page,
      filter,
      sort,
      dealer,
      partialExternalId,
    } = postBodyFromFilters;
    const filterBody = {
      dealer,
      partialExternalId,
      page,
      filter: {
        ...filter,
        // TODO: should revert this, once the classified team fix the issue. for more info: https://heycar.atlassian.net/browse/PROMO-1977
        //state: [DEALER_LISTING_PUBLISHED_STATE, DEALER_LISTING_PAUSED_STATE],
        state: [DEALER_LISTING_PUBLISHED_STATE],
      },
      size,
      ...(sort.length > 0 ? { sort } : null),
    };
    const request = {
      method: 'POST',
      body: JSON.stringify(filterBody),
    };

    dispatch({ type: ActionTypes.GET_DEALER_LISTINGS_REQUEST });

    return dispatch(apiCall(url, request))
      .then(payload =>
        dispatch({ type: ActionTypes.GET_DEALER_LISTINGS_SUCCESS, payload }),
      )
      .catch(error => {
        dispatch({ type: ActionTypes.GET_DEALER_LISTINGS_FAILURE, error });
      });
  };
};

export const toggleDealerListingState = listing => {
  return dispatch => {
    const { state } = listing;
    let newState = DEALER_LISTING_PUBLISHED_STATE;

    if (state === DEALER_LISTING_PUBLISHED_STATE) {
      newState = DEALER_LISTING_PAUSED_STATE;
    }
    const url = `/dealer-portal/listings/${listing.id}/states/${newState}`;

    // TODO we don't handle this case because we do not have a pending state in the designs
    dispatch({ type: ActionTypes.DEALER_LISTING_TOGGLE_REQUEST });

    return dispatch(apiCall(url, { method: 'PUT' }))
      .then(payload => {
        return dispatch({
          type: ActionTypes.DEALER_LISTING_TOGGLE_SUCCESS,
          payload,
        });
      })
      .catch(error => {
        // TODO we don't handle this case because we do not have an error state in the designs
        return dispatch({
          type: ActionTypes.DEALER_LISTING_TOGGLE_FAILURE,
          error,
        });
      });
  };
};

export const setFilters = filters => ({
  type: ActionTypes.SET_FILTERS,
  payload: filters,
});

export const resetListings = () => ({
  type: ActionTypes.RESET_LISTINGS,
});

export const clearListingsCache = () => ({
  type: ActionTypes.CLEAR_LISTINGS_CACHE,
});

export const cacheDealerListings = listingsKeyValuePair => ({
  type: ActionTypes.CACHE_DEALER_LISTINGS,
  listingsKeyValuePair,
});

export const applyCachedDealerListings = cachedListingsData => ({
  type: ActionTypes.APPLY_CACHED_DEALER_LISTINGS,
  cachedListingsData,
});

export const clearDealerFilters = () => ({
  type: ActionTypes.CLEAR_DEALER_FILTERS,
});

export const startCacheClearTask = () => ({
  type: ActionTypes.START_CACHE_CLEAR_TASK,
});

export const stopCacheClearTask = () => ({
  type: ActionTypes.STOP_CACHE_CLEAR_TASK,
});
